import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '@environments/environment';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { INDRABookingService } from '@ibe.services/booking.indra.service';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Observable } from 'rxjs';
import * as fromStore from '../../../store';
import { FeaturesMap, Flight } from '@ibe.models/flight.model.lib';
import { brandExtraFeature, packFeature } from '@ibe.components/booking/flights/brand/brand';
import { Bundles } from '@ibe.components/booking/extras/bundles/bundles';
import { takeWhile } from 'rxjs/operators';
import { ANCILLARY_PRODUCT_PACKS } from '@ibe.config';

const moment = extendMoment(Moment);

@Component({
    selector: 'app-pack-modal',
    templateUrl: './pack-modal.indra.component.html',
    styleUrls: ['./pack-modal.component.scss'],
    host: { 'class': 'modal--packs' }
})
export class INDRAPackModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {

    isAlive = true;

    extra: brandExtraFeature;

    _flight: any;

    extra_features: brandExtraFeature[] = [];
    bundle_features: any = [];
    available_bundles: any = [];

    flight: any;
    selectedExtra: string;
    bundle: Bundles;

    bookingNotification;
    activeBookedTrip = null;

    constructor(
        protected bookingService: INDRABookingService,
        private store: Store<fromStore.State>,
        protected modalService: ModalService,
        private sidebarService: SidebarService,
    ) {
        super(modalService);

        moment.locale(environment.locale);

    }

    ngOnInit() {
        this.bundle = this.data[0].bundle;
        this.flight = this.data[0].flight;
        this.selectedExtra = this.data[0].selectedExtra;

        this.INDRA_setUpFlights();
        this.INDRA_setExtrasData();
    }

    INDRA_setUpFlights() {
        this._flight = this.flight;
    }

    INDRA_setExtrasData() {
        this.extra = this.bundle.extras_availables.find(e => e.id == this.selectedExtra);

        this.bundle_features = Object.assign([], this.bundle.INDRA_getPacksbyExtra(this.extra));
        this.bundle_features.forEach(bundle => {
            if (this.INDRA_packSegmentsAvailable(bundle)) {
                this.available_bundles.push(bundle);
            }
        });
        if (this.available_bundles.length === 0) {
            this.INDRA_handleOpenExtra(this.extra);
        }
    }

    ngOnDestroy() {
        this.isAlive = false;
    }

    INDRA_close() {
        this.closeModal();
    }

    INDRA_getCardStyles() {
        return {
            'modal-pack': true,
            'single-pack': this.available_bundles && this.available_bundles.length == 1,
        };
    }

    INDRA_handleOpenPack(pack: any) {
        this.INDRA_close();
        this.sidebarService.openSidebar(["packs", { flight: this._flight.details.assignedFlightId, packId: this.getPackCode(pack) }]);
    }

    INDRA_handleOpenExtra(feature: any) {
        this.INDRA_close();
        this.sidebarService.openSidebar([feature.action.route, { flight: this._flight.details.assignedFlightId, purchased: this.featureCountAdded(feature) }]);
    }

    featureCountAdded(feature) {
        return this.bookingNotification === 'purchase-completed' && feature.type === 'extra' && new FeaturesMap(this._flight).getCountAdded(feature);
    }

    INDRA_printImage() {
        const IMAGE = 'arrow-bundle-card.svg';
        return 'url(assets/images/ancillaries/packs/' + IMAGE + ')';
    }

    getPackCode(pack: any) {
        return pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].code;
    }


    INDRA_packSegmentsAvailable(pack) {
        let availableSegments = [];
        let availableBundleCodes = [this.selectedExtra];
        this.bundle_features.forEach(bundle => {
            availableBundleCodes.push(bundle.ancillaryList[0].type)
        });


        if (pack.ancillaryList[0].catalog && pack.ancillaryList[0].catalog.length) {
            let addedFeatures = this.bundle.features_added.filter(feature => availableBundleCodes.includes(feature.code))
            let ancillariesInPack = [];
            pack.ancillaryList[0].catalog[0].passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(anc => {
               ancillariesInPack.push(anc.code);
            });

            let addedPackAncillaries = [];
            if (this.bundle.features_added && this.bundle.features_added.length) {
                this.bundle.features_added.forEach(feature => {
                    if (ANCILLARY_PRODUCT_PACKS.includes(feature.code)) {
                        // Feature added is pack, so must compare ancillaries to theck is pack is available
                        const addedPack = this.bundle.bundle_features.find((bundle => bundle.ancillaryList[0].type === feature.code));
                        let addedSegments = [];
                        addedPack.ancillaryList[0].catalog.forEach(catalog => {
                            if (this.bundle.features_added.find(bundle => (bundle.code === addedPack.ancillaryList[0].type) && (bundle.segmentId == catalog.segmentId))) {
                                addedSegments.push(catalog);
                            }
                        })
                        addedSegments.forEach(segment => {
                            segment.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(anc => {
                                addedPackAncillaries.push({
                                    segmentId: segment.segmentId,
                                    flightId: segment.flightId,
                                    code: anc.code
                                });
                            });
                        });
                    }
                });
            }

            pack.ancillaryList[0].catalog.forEach(catalog => {
                if (!addedFeatures.find(feature => catalog.segmentId === feature.segmentId)) {
                    availableSegments.push(catalog);
                }
                // Check ancillaries in added packs to see if current pack is available
                availableSegments.forEach((segment, index) => {
                    segment.passengers[0].codeList[0].ancillaryPackInfo.ancillaryDescription.forEach(anc => {
                        if (addedPackAncillaries.find(feature => (feature.code === anc.code && feature.segmentId === segment.segmentId) || (feature.flightId !== segment.flightId))) {
                            availableSegments.splice(index, 1);
                        }
                    });
                });
            });
        }


        if (availableSegments.length) {
            return true;
        } else {
            return false;
        }
    }

    INDRA_getPackSegments(bundle) {
        let type;
        if (bundle.ancillaryList[0]) {
            type = bundle.ancillaryList[0].type;
        }

		let packsPerSegment = [];
		this.bundle_features.forEach(pack => {
			if (pack.ancillaryList[0].type === type) {
                if (pack.ancillaryList[0].catalog) {
                    pack.ancillaryList[0].catalog.forEach(catalog => {
                        if (catalog.flightId == this.flight.details.idFlight.toString()) {
                            packsPerSegment.push({
                                ...catalog,
                                itemId: pack.ancillaryList[0].itemId,
                                type: pack.ancillaryList[0].type
                            });
                        }
                    });
                }
			}
		});
        

		return packsPerSegment;
	}
}
